import axios from "axios";

export const loadAllLeadAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&page=${
        payload.currentPage
      }&countries=[${payload.countryFilters}]&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&statuses=[${payload.statusFilters}]&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleLeadAPI = (payload) => {
  return axios
    .get(`/leads/${payload.leadId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
